import _extends from '@babel/runtime/helpers/esm/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/esm/objectWithoutProperties';
import React from 'react';
import InputImpl from './InputImpl.js';
export { default as InputAddonWrapper } from './InputAddonWrapper.js';
import '@babel/runtime/helpers/esm/typeof';
import '@babel/runtime/helpers/esm/classCallCheck';
import '@babel/runtime/helpers/esm/createClass';
import '@babel/runtime/helpers/esm/assertThisInitialized';
import '@babel/runtime/helpers/esm/inherits';
import '@babel/runtime/helpers/esm/possibleConstructorReturn';
import '@babel/runtime/helpers/esm/getPrototypeOf';
import '@babel/runtime/helpers/esm/defineProperty';
import 'prop-types';
import 'lodash';
import '@elliemae/ds-classnames';
import '@elliemae/ds-icons/CloseCircle';
import '@elliemae/ds-button';
import '@elliemae/ds-tooltip';
import './showEllipsis.js';
import '@babel/runtime/helpers/esm/toConsumableArray';

var DSInput = function DSInput(_ref) {
  var _ref$containerProps = _ref.containerProps,
      containerProps = _ref$containerProps === void 0 ? {} : _ref$containerProps,
      id = _ref.id,
      _ref$autoFocus = _ref.autoFocus,
      autoFocus = _ref$autoFocus === void 0 ? false : _ref$autoFocus,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      _ref$clearable = _ref.clearable,
      clearable = _ref$clearable === void 0 ? false : _ref$clearable,
      _ref$name = _ref.name,
      name = _ref$name === void 0 ? '' : _ref$name,
      _ref$maxLength = _ref.maxLength,
      maxLength = _ref$maxLength === void 0 ? 255 : _ref$maxLength,
      _ref$minLength = _ref.minLength,
      minLength = _ref$minLength === void 0 ? 0 : _ref$minLength,
      _ref$fluidWidth = _ref.fluidWidth,
      fluidWidth = _ref$fluidWidth === void 0 ? false : _ref$fluidWidth,
      _ref$disableTooltip = _ref.disableTooltip,
      disableTooltip = _ref$disableTooltip === void 0 ? true : _ref$disableTooltip,
      placeholder = _ref.placeholder,
      _ref$value = _ref.value,
      value = _ref$value === void 0 ? '' : _ref$value,
      _ref$hasError = _ref.hasError,
      hasError = _ref$hasError === void 0 ? false : _ref$hasError,
      _ref$readOnly = _ref.readOnly,
      readOnly = _ref$readOnly === void 0 ? false : _ref$readOnly,
      _ref$innerRef = _ref.innerRef,
      innerRef = _ref$innerRef === void 0 ? null : _ref$innerRef,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'text' : _ref$type,
      _ref$min = _ref.min,
      min = _ref$min === void 0 ? undefined : _ref$min,
      _ref$max = _ref.max,
      max = _ref$max === void 0 ? undefined : _ref$max,
      _ref$leftComponent = _ref.leftComponent,
      leftComponent = _ref$leftComponent === void 0 ? null : _ref$leftComponent,
      _ref$rightComponent = _ref.rightComponent,
      rightComponent = _ref$rightComponent === void 0 ? null : _ref$rightComponent,
      _ref$required = _ref.required,
      required = _ref$required === void 0 ? false : _ref$required,
      _ref$customInputType = _ref.customInputType,
      customInputType = _ref$customInputType === void 0 ? null : _ref$customInputType,
      variant = _ref.variant,
      _ref$isShowElipsisAct = _ref.isShowElipsisActive,
      isShowElipsisActive = _ref$isShowElipsisAct === void 0 ? true : _ref$isShowElipsisAct,
      otherProps = _objectWithoutProperties(_ref, ["containerProps", "id", "autoFocus", "disabled", "className", "clearable", "name", "maxLength", "minLength", "fluidWidth", "disableTooltip", "placeholder", "value", "hasError", "readOnly", "innerRef", "type", "min", "max", "leftComponent", "rightComponent", "required", "customInputType", "variant", "isShowElipsisActive"]);

  return /*#__PURE__*/React.createElement(InputImpl, _extends({}, otherProps, {
    "aria-label": otherProps['aria-label'],
    autoFocus: autoFocus,
    className: "".concat(className, " ").concat(disabled ? 'input-disabled' : ''),
    clearable: clearable,
    containerProps: containerProps,
    customInputType: customInputType,
    "data-testid": otherProps['data-testid'] || 'ds-input_main-component',
    disabled: disabled,
    disableTooltip: disableTooltip,
    fluidWidth: fluidWidth,
    hasError: hasError,
    id: id,
    innerRef: innerRef,
    isShowElipsisActive: isShowElipsisActive,
    leftComponent: leftComponent,
    max: max,
    maxLength: maxLength,
    min: min,
    minLength: minLength,
    name: name,
    placeholder: placeholder,
    readOnly: readOnly,
    required: required,
    rightComponent: rightComponent,
    type: type,
    value: value,
    variant: variant
  }));
};

export default DSInput;
//# sourceMappingURL=DSInput.js.map
